var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgZincpart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 42,
    viewBox: "0 0 128 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.0622 20.8479L28.154 25.4289V16.6707L36.0622 20.8479ZM7.86597 16.2021L7.88006 25.341L0.0498047 21.0834L7.86597 16.2021Z",
    fill: "#7B7B7B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6792 40.9981L36.1094 30.9354V22.2128L27.0045 27.4772L26.9249 4.76848L18.6651 0L18.6792 40.9981ZM17.3722 0.0862473L0 10.1158V19.6005L9.03938 14.0094V36.2322L9.10158 36.2678L9.03938 36.3035V36.3325L14.8213 39.5701L17.3855 41.0504L17.3722 0.0862473Z",
    fill: "#7B7B7B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8973 32.4161H95.5742L82.5674 12.741V32.4161H78.2443V6.03027H82.5674L95.5742 25.6681V6.03027H99.8973V32.4161ZM73.6574 6.03027V32.4161H69.3558V6.03027H73.6574ZM52.5293 28.6577H64.7665V32.4161H47.415V29.0376L59.6141 9.78949H47.415V6.03027H64.7665V9.40967L52.5293 28.6577Z",
    fill: "#7B7B7B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.853 26.9694C125.465 30.3563 121.522 32.5672 117.063 32.5672C109.776 32.5672 103.869 26.6609 103.869 19.373C103.869 12.0868 109.776 6.17969 117.063 6.17969C121.132 6.17969 124.771 8.02074 127.191 10.9167L124.237 13.383C122.557 11.1729 119.968 9.75646 117.063 9.75646C112 9.75646 107.895 14.0622 107.895 19.373C107.895 24.6839 112 28.9888 117.063 28.9888C120.235 28.9888 123.03 27.3003 124.676 24.7345L127.853 26.9694Z",
    fill: "#7B7B7B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZincpart);
export default __webpack_public_path__ + "static/media/zincpart.e2250a245bc797495096d92920291f37.svg";
export { ForwardRef as ReactComponent };